module.exports = __webpack_public_path__ + "img/lepic-icon.9029e55e.svg";